import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { resolveRemoteUIMessage, useRemoteUICopy } from './copy.js';
import { useState } from 'react';
import { ResourceCard } from './ResourceCard.js';
export function ResourceList({ bindings, resources, onRequest }) {
    const copy = useRemoteUICopy();
    const [pending, setPending] = useState(() => new Set());
    const [failures, setFailures] = useState({});
    async function request(binding) {
        if (!onRequest || pending.has(binding.resourceId))
            return;
        setPending((current) => new Set(current).add(binding.resourceId));
        setFailures((current) => {
            const { [binding.resourceId]: _previous, ...remaining } = current;
            return remaining;
        });
        try {
            await onRequest(binding);
        }
        catch (error) {
            setFailures((current) => ({
                ...current,
                [binding.resourceId]: error instanceof Error && error.message ? { text: error.message } : { key: 'resourceRequestFailed' },
            }));
        }
        finally {
            setPending((current) => {
                const next = new Set(current);
                next.delete(binding.resourceId);
                return next;
            });
        }
    }
    if (bindings.length === 0)
        return null;
    return _jsxs("section", { className: "agent-resources", "aria-label": copy.referencedResources, children: [_jsx("h4", { children: copy.resources }), _jsx("ul", { children: bindings.map((binding) => _jsx(ResourceCard, { binding: binding, detail: resources[binding.resourceId], pending: pending.has(binding.resourceId), failure: failures[binding.resourceId] ? resolveRemoteUIMessage(copy, failures[binding.resourceId]) : undefined, onRequest: onRequest ? async () => request(binding) : undefined }, `${binding.resourceId}-${binding.locator}`)) })] });
}
//# sourceMappingURL=ResourceList.js.map